import React, { memo } from 'react'
import { Row, Col, Input, Form, Checkbox, Button, AutoComplete } from 'antd'
import classNames from 'classnames'

import classes from './styles.module.scss'
import { ModalTermsAndConditions } from 'components'
import { useRegisterForm } from './useRegisterForm'

const RegisterForm: React.FunctionComponent<any> = ({ handleRegistration }) => {
	const [form] = Form.useForm()
	const {
		handleAgreement,
		onFinish,
		showTermsAndConditionsModal,
		toggleTermsAndConditionsCheckbox,
		toggleTermsAndConditionsModal,
		termsAndConditionsCheckbox,
		chillPackCommunitiesOptions,
		onSelectChillPackCompany,
		searchChillPackCommunities,
	} = useRegisterForm({ form, handleRegistration })

	return (
		<>
			<Form
				name="chill_pack"
				initialValues={{ remember: true }}
				onFinish={onFinish}
				form={form}
			>
				<div className={classes.container}>
					<Row className={classes.row} gutter={8}>
						<Col className={classes.column} xs={24} md={12}>
							<Form.Item
								name="firstName"
								rules={[
									{
										required: true,
										message: 'Prenumele este obligatoriu.',
									},
								]}
								requiredMark={true}
							>
								<Input
									id="firstName"
									type={'text'}
									placeholder={'Prenume'}
								/>
							</Form.Item>
						</Col>
						<Col className={classes.column} xs={24} md={12}>
							<Form.Item
								name="lastName"
								rules={[
									{
										required: true,
										message: 'Numele este obligatoriu.',
									},
								]}
								requiredMark={true}
							>
								<Input
									id="name"
									type={'text'}
									placeholder={'Nume'}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row className={classes.row} gutter={8}>
						<Col className={classes.column} xs={24} md={12}>
							<Form.Item
								name="email"
								requiredMark={true}
								rules={[
									{
										required: true,
										message:
											'Adresa de e-mail este obligatorie.',
									},
								]}
							>
								<Input
									id="email"
									type={'email'}
									placeholder={'E-mail'}
								/>
							</Form.Item>
						</Col>
						<Col className={classes.column} xs={24} md={12}>
							<Form.Item
								name="company"
								rules={[
									{
										required: true,
										message: 'Compania este obligatorie.',
									},
								]}
								requiredMark={true}
							>
								<AutoComplete
									options={chillPackCommunitiesOptions}
									onSelect={(value, option: any) =>
										onSelectChillPackCompany(value, option)
									}
									onSearch={searchChillPackCommunities}
									placeholder="Companie"
								/>
							</Form.Item>
						</Col>
					</Row>

					<Row className={classes.row} gutter={8}>
						<Col className={classes.column} span={24}>
							<div className={classes.termsAndConditions}>
								<Checkbox
									onChange={toggleTermsAndConditionsCheckbox}
									checked={termsAndConditionsCheckbox}
								>
									Am citit si sunt de acord cu
								</Checkbox>
								<span
									className={classes.termsAndConditionsModal}
									onClick={event =>
										toggleTermsAndConditionsModal(event)
									}
								>
									Termeni si Conditii
								</span>
							</div>
						</Col>
					</Row>
					<Row className={classes.row}>
						<Col className={classes.column} span={24}>
							<div className={classes.divBottomInfoText}>
								{`Avand in vedere situatia generata de Covid,
								in programul campaniei pot aparea modificari ale
								locatiilor si/sau datelor de distributie. Vom
								comunica prin email update-urile pe masura ce
								apar. Pentru sugestii/intrebari, scrie-ne pe
								contact@cv30.co`}
							</div>
						</Col>
					</Row>
					<Row className={classes.row} gutter={8}>
						<Col className={classes.column} span={24}>
							<div
								className={classNames(classes.saveButton, {
									[classes.disabledSaveButton]:
										!termsAndConditionsCheckbox,
								})}
							>
								<Button
									htmlType={'submit'}
									type="primary"
									disabled={!termsAndConditionsCheckbox}
								>
									{'Salveaza'}
								</Button>
							</div>
						</Col>
					</Row>
				</div>
			</Form>
			<ModalTermsAndConditions
				handleAgreement={handleAgreement}
				termsAndConditionsModal={showTermsAndConditionsModal}
			/>
		</>
	)
}

export default memo((props: any) => <RegisterForm {...props} />)
